module.exports = __webpack_public_path__ + "static/3-f22357b75bcc6a45540a9e9f11816375.jpg";